type TitleValueFieldProps = {
  title: string;
  value: string;
};

const TitleValueField = ({ title, value }: TitleValueFieldProps) => {
  return (
    <div className="flex flex-col min-w-0">
      <span className="text-xs font-medium truncate">{title}:</span>
      <span className="text-sm font-medium truncate">{value}</span>
    </div>
  );
};

export default TitleValueField;
